// Plugin
import Swiper from 'swiper/bundle';
// import { Navbar } from 'bootstrap';
import WOW from 'wow.js';

new WOW().init();

// ViewportHeight
const updateViewportHeight = () => {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};
updateViewportHeight();

// Brand
const Brand = document.querySelector('.container-brand');
setTimeout(() => {
    Brand.style.pointerEvents = 'auto';
}, 1000);

// Press Slider
let swiper = new Swiper(".press-slider", {
    autoplay: {
        delay: 5000,
    },
    slidesPerView: 1,
    spaceBetween: 12,
    breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 36
        },
        575: {
            slidesPerView: 2,
            spaceBetween: 24
        },
    },
    speed: 1000,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});